import React from 'react';
import PropTypes from 'prop-types';
import { ToggleComponent } from '../../../components/Toggle';
import {
  ENABLE_LOCAL_SPEND,
  getSettingValue,
  isStoreValid,
  LOCAL_BRANCH_SPEND,
} from '../../../constants/utils';

const PerformanceHeader = ({
  showSpendToggle,
  spendToggleState,
  setSpendToggleState,
  isDisabled,
  userData,
  storeId,
  options,
  subBranchDashboard,
}) => {
  return (
    <div
      style={{
        width: '90%',
        textAlign: 'left',
        margin: 'auto',
        fontSize: '1.5rem',
        fontWeight: '500',
        lineHeight: '1.6',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <span style={{ minWidth: '500px' }}>
        {subBranchDashboard ? 'Overall Performance Subbranches' : 'Overall Performance'} - All
        Channels and Tiers
      </span>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        {showSpendToggle &&
          getSettingValue(userData?.data?.settings, ENABLE_LOCAL_SPEND) &&
          storeId?.length > 0 && (
            <ToggleComponent
              setState={setSpendToggleState}
              currentState={spendToggleState}
              disabled={isDisabled || storeId?.length === 0}
              toggleText={LOCAL_BRANCH_SPEND}
              hideToggle={isStoreValid(storeId, options, true)}
            />
          )}
      </div>
    </div>
  );
};

PerformanceHeader.propTypes = {
  // Toggle control props
  showSpendToggle: PropTypes.bool,
  spendToggleState: PropTypes.bool,
  setSpendToggleState: PropTypes.func,

  // Disabled state
  isDisabled: PropTypes.bool,

  // User data with settings
  userData: PropTypes.shape({
    data: PropTypes.shape({
      settings: PropTypes.arrayOf(
        PropTypes.shape({
          key: PropTypes.string,
          value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
        })
      ),
    }),
  }),

  // Store selection
  storeId: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),

  // Store options
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string.isRequired,
      region: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ),
  subBranchDashboard: PropTypes.bool,
};

export default React.memo(PerformanceHeader);
